// import { useEffect } from 'react';
// import metaDescriptions from './metaDescriptions'; // Import the mapping

// const MetaDescription = ({ pageLink }) => {
//   useEffect(() => {
//     const description = metaDescriptions[pageLink] || "Default meta description if not found";

//     const metaDescriptionTag = document.querySelector('meta[name="description"]');
//     if (metaDescriptionTag) {
//       metaDescriptionTag.setAttribute('content', description);
//     } else {
//       const newMetaTag = document.createElement('meta');
//       newMetaTag.setAttribute('name', 'description');
//       newMetaTag.setAttribute('content', description);
//       document.head.appendChild(newMetaTag);
//     }
//   }, [pageLink]);

//   return null;
// };

// export default MetaDescription;


// import { useEffect } from 'react';
// import metaDescriptions from './metaDescriptions'; // Import the mapping

// const MetaDescriptionAndKeywords = ({ pageLink }) => {
//   useEffect(() => {
//     // Get the description, keywords, and ogTitle based on the page link
//     const { description, keywords, ogTitle } = metaDescriptions[pageLink] || {
//       description: "MH Cockpit, the top aviation college in Chennai and Tamil Nadu, specializes in advanced aviation training that sets students on the path to success. With an emphasis on industry-standard education and hands-on experience, expert instructors, and state-of-the-art facilities, we offer comprehensive programs for aspiring pilots and aviation professionals, laying the foundation for successful careers in the skies.",
//       keywords: "aviation, training",
//       ogTitle: "MH Cockpit - Aviation Training"
//     };

//     // Update the meta description tag
//     let metaDescriptionTag = document.querySelector('meta[name="description"]');
//     if (metaDescriptionTag) {
//       metaDescriptionTag.setAttribute('content', description);
//     } else {
//       const newMetaDescriptionTag = document.createElement('meta');
//       newMetaDescriptionTag.setAttribute('name', 'description');
//       newMetaDescriptionTag.setAttribute('content', description);
//       document.head.appendChild(newMetaDescriptionTag);
//     }

//     // Update the meta keywords tag
//     let metaKeywordsTag = document.querySelector('meta[name="keywords"]');
//     if (metaKeywordsTag) {
//       metaKeywordsTag.setAttribute('content', keywords);
//     } else {
//       const newMetaKeywordsTag = document.createElement('meta');
//       newMetaKeywordsTag.setAttribute('name', 'keywords');
//       newMetaKeywordsTag.setAttribute('content', keywords);
//       document.head.appendChild(newMetaKeywordsTag);
//     }

//     // Update the Open Graph og:title tag
//     let metaOgTitleTag = document.querySelector('meta[property="og:title"]');
//     if (metaOgTitleTag) {
//       metaOgTitleTag.setAttribute('content', ogTitle);
//     } else {
//       const newMetaOgTitleTag = document.createElement('meta');
//       newMetaOgTitleTag.setAttribute('property', 'og:title');
//       newMetaOgTitleTag.setAttribute('content', ogTitle);
//       document.head.appendChild(newMetaOgTitleTag);
//     }

//   }, [pageLink]);

//   return null;
// };

// export default MetaDescriptionAndKeywords;


// import { useEffect } from 'react';
// import metaDescriptions from './metaDescriptions'; // Import the mapping

// const MetaDescriptionAndKeywords = ({ pageLink }) => {
//   useEffect(() => {
//     const {
//       title,
//       description,
//       keywords,
//       ogTitle,
//       ogDescription,
//       ogUrl,
//       ogType,
//       canonicalUrl,
//     } = metaDescriptions[pageLink] || {
//       title: "MH Cockpit - Best Aviation College in Chennai - Tamilnadu",
//       description: "MH Cockpit, the top aviation college in Chennai and Tamil Nadu...",
//       keywords: "aviation, training",
//       ogTitle: "MH Cockpit - Best Aviation College in Chennai - Tamilnadu",
//       ogDescription: "MH Cockpit is the leading aviation training institute in Chennai...",
//       ogUrl: `https://www.mhcockpit.com${pageLink}`,
//       ogType: "website",
//       canonicalUrl: `https://www.mhcockpit.com${pageLink}`,
//     };

//     // Set <title>
//     document.title = title;

//     const setOrCreateMetaTag = (selector, attr, value, isProperty = false) => {
//       let tag = document.querySelector(selector);
//       if (tag) {
//         tag.setAttribute(attr, value);
//       } else {
//         const newTag = document.createElement('meta');
//         newTag.setAttribute(isProperty ? 'property' : 'name', attr);
//         newTag.setAttribute('content', value);
//         document.head.appendChild(newTag);
//       }
//     };

//     // Meta tags
//     setOrCreateMetaTag('meta[name="description"]', 'name', 'description');
//     setOrCreateMetaTag('meta[name="description"]', 'content', description);

//     setOrCreateMetaTag('meta[name="keywords"]', 'name', 'keywords');
//     setOrCreateMetaTag('meta[name="keywords"]', 'content', keywords);

//     // Open Graph tags
//     setOrCreateMetaTag('meta[property="og:title"]', 'property', 'og:title', true);
//     setOrCreateMetaTag('meta[property="og:title"]', 'content', ogTitle, true);

//     setOrCreateMetaTag('meta[property="og:description"]', 'property', 'og:description', true);
//     setOrCreateMetaTag('meta[property="og:description"]', 'content', ogDescription, true);

//     setOrCreateMetaTag('meta[property="og:url"]', 'property', 'og:url', true);
//     setOrCreateMetaTag('meta[property="og:url"]', 'content', ogUrl, true);

//     setOrCreateMetaTag('meta[property="og:type"]', 'property', 'og:type', true);
//     setOrCreateMetaTag('meta[property="og:type"]', 'content', ogType, true);

//     // Canonical link
//     let canonicalTag = document.querySelector('link[rel="canonical"]');
//     if (canonicalTag) {
//       canonicalTag.setAttribute('href', canonicalUrl);
//     } else {
//       const newCanonicalTag = document.createElement('link');
//       newCanonicalTag.setAttribute('rel', 'canonical');
//       newCanonicalTag.setAttribute('href', canonicalUrl);
//       document.head.appendChild(newCanonicalTag);
//     }
//   }, [pageLink]);

//   return null;
// };

// export default MetaDescriptionAndKeywords;




// import { useEffect } from "react";
// import metaDescriptions from "./metaDescriptions"; // Import your SEO mapping

// const MetaDescriptionAndKeywords = ({ pageLink }) => {
//   useEffect(() => {
//     const {
//       title,
//       description,
//       keywords,
//       robots,
//       ogTitle,
//       ogDescription,
//       ogUrl,
//       ogType,
//       ogLocale,
//       canonicalUrl,
//       twitterCard,
//       twitterTitle,
//       twitterDescription,
//     } = metaDescriptions[pageLink] || {
//       title: "Al Bidayah Groups | Travel, Education & Services in Malaysia",
//       description:
//         "Your trusted Malaysian group for travel, education, logistics, property & restaurants. Local roots, global reach.",
//       keywords:
//         "Al Bidayah Groups, Malaysia travel agency, overseas education Malaysia, logistics services, property Malaysia, restaurants Malaysia, travel group Kuala Lumpur, Al Bidayah Malaysia",
//       robots: "index, follow",
//       ogTitle: "Al Bidayah Groups | Travel, Education & Services in Malaysia",
//       ogDescription:
//         "Leading Malaysian group offering travel, education, logistics, property & restaurant services worldwide.",
//       ogUrl: `https://www.albidayahgroups.com${pageLink}`,
//       ogType: "website",
//       ogLocale: "en_MY",
//       canonicalUrl: `https://www.albidayahgroups.com${pageLink}`,
//       twitterCard: "summary_large_image",
//       twitterTitle:
//         "Al Bidayah Groups | Travel, Education & Services in Malaysia",
//       twitterDescription:
//         "Local roots, global reach — Al Bidayah Groups leads Malaysia’s travel, education, logistics & restaurant sectors.",
//     };

//     document.title = title;

//     const setOrCreateMetaTag = (selector, attr, value, isProperty = false) => {
//       let tag = document.querySelector(selector);
//       if (tag) {
//         tag.setAttribute(attr, value);
//       } else {
//         const newTag = document.createElement("meta");
//         newTag.setAttribute(isProperty ? "property" : "name", attr);
//         newTag.setAttribute("content", value);
//         document.head.appendChild(newTag);
//       }
//     };

//     // --- BASIC META TAGS ---
//     setOrCreateMetaTag('meta[name="description"]', "content", description);
//     setOrCreateMetaTag('meta[name="keywords"]', "content", keywords);
//     setOrCreateMetaTag('meta[name="robots"]', "content", robots);

//     // --- OPEN GRAPH TAGS ---
//     setOrCreateMetaTag('meta[property="og:title"]', "content", ogTitle, true);
//     setOrCreateMetaTag(
//       'meta[property="og:description"]',
//       "content",
//       ogDescription,
//       true
//     );
//     setOrCreateMetaTag('meta[property="og:url"]', "content", ogUrl, true);
//     setOrCreateMetaTag('meta[property="og:type"]', "content", ogType, true);
//     setOrCreateMetaTag(
//       'meta[property="og:locale"]',
//       "content",
//       ogLocale,
//       true
//     );

//     // --- TWITTER META TAGS ---
//     setOrCreateMetaTag('meta[name="twitter:card"]', "content", twitterCard);
//     setOrCreateMetaTag('meta[name="twitter:title"]', "content", twitterTitle);
//     setOrCreateMetaTag(
//       'meta[name="twitter:description"]',
//       "content",
//       twitterDescription
//     );

//     // --- CANONICAL LINK ---
//     let canonicalTag = document.querySelector('link[rel="canonical"]');
//     if (canonicalTag) {
//       canonicalTag.setAttribute("href", canonicalUrl);
//     } else {
//       const newCanonicalTag = document.createElement("link");
//       newCanonicalTag.setAttribute("rel", "canonical");
//       newCanonicalTag.setAttribute("href", canonicalUrl);
//       document.head.appendChild(newCanonicalTag);
//     }
//   }, [pageLink]);

//   return null;
// };

// export default MetaDescriptionAndKeywords;




import { useEffect } from "react";
import metaDescriptions from "./metaDescriptions"; // Your mapping file

const MetaDescriptionAndKeywords = ({ pageLink }) => {
  useEffect(() => {
    const {
      title,
      description,
      keywords,
      robots,
      ogTitle,
      ogDescription,
      ogUrl,
      ogType,
      ogLocale,
      canonicalUrl,
      twitterCard,
      twitterTitle,
      twitterDescription,
    } = metaDescriptions[pageLink] || {
      // 🔸 Default fallback (Home page)
      title: "Al Bidayah Groups | Travel, Education & Services in Malaysia",
      description:
        "Your trusted Malaysian group for travel, education, logistics, property & restaurants. Local roots, global reach.",
      keywords:
        "Al Bidayah Groups, Malaysia travel agency, overseas education Malaysia, logistics services, property Malaysia, restaurants Malaysia, travel group Kuala Lumpur, Al Bidayah Malaysia",
      robots: "index, follow",
      ogTitle: "Al Bidayah Groups | Travel, Education & Services in Malaysia",
      ogDescription:
        "Leading Malaysian group offering travel, education, logistics, property & restaurant services worldwide.",
      ogUrl: `https://www.albidayahgroups.com${pageLink}`,
      ogType: "website",
      ogLocale: "en_MY",
      canonicalUrl: `https://www.albidayahgroups.com${pageLink}`,
      twitterCard: "summary_large_image",
      twitterTitle:
        "Al Bidayah Groups | Travel, Education & Services in Malaysia",
      twitterDescription:
        "Local roots, global reach — Al Bidayah Groups leads Malaysia’s travel, education, logistics & restaurant sectors.",
    };

    // ✅ Set page title
    document.title = title;

    /**
     * Helper to set or create <meta> tags cleanly
     */
    const setOrCreateMetaTag = (selector, attrName, attrValue, isProperty = false) => {
      let tag = document.head.querySelector(selector);
      if (!tag) {
        tag = document.createElement("meta");
        tag.setAttribute(isProperty ? "property" : "name", attrName);
        document.head.appendChild(tag);
      }
      tag.setAttribute("content", attrValue);
    };

    // ✅ Basic SEO tags
    if (description) setOrCreateMetaTag('meta[name="description"]', "description", description);
    if (keywords) setOrCreateMetaTag('meta[name="keywords"]', "keywords", keywords);
    if (robots) setOrCreateMetaTag('meta[name="robots"]', "robots", robots);

    // ✅ Open Graph tags
    if (ogTitle) setOrCreateMetaTag('meta[property="og:title"]', "og:title", ogTitle, true);
    if (ogDescription)
      setOrCreateMetaTag('meta[property="og:description"]', "og:description", ogDescription, true);
    if (ogUrl) setOrCreateMetaTag('meta[property="og:url"]', "og:url", ogUrl, true);
    if (ogType) setOrCreateMetaTag('meta[property="og:type"]', "og:type", ogType, true);
    if (ogLocale) setOrCreateMetaTag('meta[property="og:locale"]', "og:locale", ogLocale, true);

    // ✅ Twitter tags
    if (twitterCard) setOrCreateMetaTag('meta[name="twitter:card"]', "twitter:card", twitterCard);
    if (twitterTitle)
      setOrCreateMetaTag('meta[name="twitter:title"]', "twitter:title", twitterTitle);
    if (twitterDescription)
      setOrCreateMetaTag('meta[name="twitter:description"]', "twitter:description", twitterDescription);

    // ✅ Canonical link
    if (canonicalUrl) {
      let canonicalTag = document.head.querySelector('link[rel="canonical"]');
      if (!canonicalTag) {
        canonicalTag = document.createElement("link");
        canonicalTag.setAttribute("rel", "canonical");
        document.head.appendChild(canonicalTag);
      }
      canonicalTag.setAttribute("href", canonicalUrl);
    }
  }, [pageLink]);

  return null;
};

export default MetaDescriptionAndKeywords;
